import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {actionAddUpdateProfile, actionAddUpdateUserProfilePic, actionGetProfileData, logout} from "../../actions/auth";
import userLogo from "../../assets/img/nophoto.png";
import userCompLogo from "../../assets/img/no-photo-BLACK.png";
import CommonInputField from "../addProperty/CommonInputField";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/material.css'
import classnames from 'classnames'
import {Link} from "react-router-dom";
import SelectSearch from "react-select-search";
import {
    actionRemoveCities,
    actionRemoveCountries,
    actionRemoveStates,
    getAllCountry, getCities, getStates
} from "../../actions/propertysAction";
import btnLoader from "../../assets/img/button-loader.svg";
import ReactCrop from "react-image-crop";

import 'react-image-crop/dist/ReactCrop.css';
import {Col, Form, Row} from "reactstrap";
import {ADD_PROPERTIES, USER_PROFILE} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import HeroSection from "../common/HerroSection/hero-section";
import CommonTextBox from "../addProperty/CommonTextBox";

class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profilePicLoader: false,
            name: '',
            specialty: '',
            website: '',
            email: '',
            mobile: '',
            gender: "M",
            country_id: '',
            state_id: '',
            city_id: '',
            zip_code: '',
            company_name: '',
            company_team_name: '',
            company_state: '',
            company_zip_code: '',
            number_of_years_in_business: '',
            designations: '',
            languages_spoken: '',
            hobbies: '',
            cites_expert: '',
            subdivisions_expert: '',
            avatar:'',
            avatar_preview:'',
            company_logo:'',
            company_logo_preview:'',
            facebook_link: '',
            instagram_link: '',
            twitter_link: '',

            errors: {},


            src: null,
            cp_src: null,
            crop: {
                unit: '%',
                width: 30,
                aspect: 1,
            },
            company_profile_crop: {
                unit: 'px',
                width: 80,
                aspect: 16 / 9,
            },
            blob: '',
            blob1: ''


        }
        this.inputOpenFileRef = React.createRef();
    }

    componentDidMount() {
        document.title = "Profile | Prime Private Network";
        this.props.getAllCountry();
        console.log(this.props.auth.user._id);
        if (this.props.auth.user._id && this.props.auth.user) {
            console.log(this.props.auth.user, "-----------")
            this.setState({
                ...this.state,
                ...this.props.auth.user,
                country_id: this.props.auth.user.country ? this.props.auth.user.country : '',
                state_id: this.props.auth.user.state ? this.props.auth.user.state : '',
                city_id: this.props.auth.user.city ? this.props.auth.user.city : '',
                company_logo_preview: this.props.auth.user.company_logo,
                avatar_preview: this.props.auth.user.avatar,
                company_logo: this.props.auth.user.company_logo.split('/')[4],
                avatar: this.props.auth.user.avatar.split('/')[4],
            }, () => {
                console.log(this.state.country, "-----");
                this.state.country_id && this.props.getStates(this.state.country_id);
                this.state.state_id && this.props.getCities(this.state.state_id);
            })
            // this.props.actionGetProfileData(this.props.auth.user._id)
        }

    }

    componentDidUpdate(prevProps, NextState) {

        if (prevProps.auth.user !== this.props.auth.user) {
            console.log(this.state.country, "----+++-");
            this.setState({
                ...this.state,
                ...this.props.auth.user,
                country_id: this.props.auth.user.country,
                state_id: this.props.auth.user.state,
                city_id: this.props.auth.user.city,
                company_logo: this.props.auth.user.company_logo.split('/')[4],
                avatar: this.props.auth.user.avatar.split('/')[4],
            }, () => {
                console.log(this.state.country, "-----");
                this.props.getStates(this.state.country);
                this.props.getCities(this.state.state);
            })

        }

    }


    /*  Image Crop */
    onSelectFile = e => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () =>
                this.setState({src: reader.result})
            );
            reader.readAsDataURL(e.target.files[0]);
        }
    };


    // If you setState the crop in here you should return false.
    onImageLoaded = image => {
        this.imageRef = image;
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({crop});
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                'newFile.jpeg'
            );
            this.setState({croppedImageUrl});
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error('Canvas is empty');
                    return;
                }
                blob.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                resolve(this.fileUrl);
                this.setState({blob}) //added by SO huy nguyen
            }, 'image/jpeg');
        });
    }

    setProfilePic = (avatar_preview,image) => {
        this.setState({avatar_preview,avatar: image})
    };
    handleProfileChange = async (e) => {
        const config = {responseType: 'blob'};
        /*let file = axios.get(this.state.croppedImageUrl, config).then(response => {
            new File([response.data], 'my_image.png', {type: "image/jpg", lastModified: new Date()});
        });*/
        var file = new File([this.state.croppedImageUrl], "my_image.png", {
            type: "image/png",
            lastModified: new Date()
        });
        let formData = new FormData();
        // formData.append('user_id', this.props.user.user_id);
        formData.append('image', this.state.blob);
        // formData.append('remove_profile', 0);
        // this.setState({profile_pic: this.state.blob.toString()});
        this.setState({profilePicLoader: true}, document.getElementById('close-profilePictureUpload') && document.getElementById('close-profilePictureUpload').click());
        try {
            await this.props.actionAddUpdateUserProfilePic(formData, this.setProfilePic);
            this.setState({
                profilePicLoader: false,
                src: null,
                blob: ''
            }, () => document.getElementById('profile-pic-selector').value = '');
        }
        catch (error) {
            this.setState({profilePicLoader: false});
            console.error({"error setting profile pic": error});
        }
    };

    /*  Image Crop Ends */

    onSelectCompanyProfileFile = e => {
        if (e.target.files && e.target.files.length > 0) {
            const reader_C = new FileReader();
            reader_C.addEventListener('load', () =>
                this.setState({cp_src: reader_C.result})
            );
            reader_C.readAsDataURL(e.target.files[0]);
        }
    };

    // If you setState the crop in here you should return false.
    onCompanyImageLoaded = image => {
        this.imageRef = image;
    };

    onCompanyImageCropComplete = company_profile_crop => {
        this.makeClientCropCompanyImage(company_profile_crop);
    };

    onCompanyImageCropChange = (company_profile_crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });

        this.setState({company_profile_crop});
    };

    async makeClientCropCompanyImage(company_profile_crop) {
        if (this.imageRef && company_profile_crop.width && company_profile_crop.height) {
            const croppedCompanyImageUrl = await this.getCompanyCroppedImg(
                this.imageRef,
                company_profile_crop,
                'newCompan' +
                'yProfileFile.jpeg'
            );
            this.setState({croppedCompanyImageUrl});
        }
    }

    getCompanyCroppedImg(image, company_profile_crop, fileName) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = company_profile_crop.width;
        canvas.height = company_profile_crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            company_profile_crop.x * scaleX,
            company_profile_crop.y * scaleY,
            company_profile_crop.width * scaleX,
            company_profile_crop.height * scaleY,
            0,
            0,
            company_profile_crop.width,
            company_profile_crop.height
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob1 => {
                if (!blob1) {
                    //reject(new Error('Canvas is empty'));
                    console.error('Canvas is empty');
                    return;
                }
                blob1.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob1);
                resolve(this.fileUrl);
                this.setState({blob1}) //added by SO huy nguyen
            }, 'image/jpeg');
        });
    }

    handleCompanyProfileChange = async (e) => {
        const config = {responseType: 'blob'};

        var file = new File([this.state.croppedCompanyImageUrl], "company_profile_image.jpg", {
            type: "image/png",
            lastModified: new Date()
        });
        let formData = new FormData();
        // formData.append('user_id', this.props.user.user_id);
        formData.append('image', this.state.blob1);
        // formData.append('remove_company_logo', 0);
        this.setState({companyProfilePicLoader: true}, document.getElementById('close-companyprofilePictureUpload') && document.getElementById('close-companyprofilePictureUpload').click());
        try {
            await this.props.actionAddUpdateUserProfilePic(formData, (company_logo_preview,image) => this.setState({company_logo_preview,company_logo:image}));

            this.setState({
                companyProfilePicLoader: false,
                cp_src: null,
                blob1: ''
            }, () => document.getElementById('company-profile-pic-selector').value = '');

        }
        catch (error) {
            this.setState({company_profilePicLoader: false});
            console.error({"error setting company profile pic": error});
        }
    };

    /*  Company Image Crop Ends */


    handleSaveValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;
        const validEmailRegex = RegExp(
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)

        const strchek1 = /^[^0-9]+([-_\s]{1}[a-z0-9]+)*$/i;

        if (!fields.name) {
            formIsValid = false;
            errors.name = "*Please Enter your Name...!";
        }
        // if (!fields.specialty) {
        //     formIsValid = false;
        //     errors.specialty = "*Please Enter your Specialty...!";
        // }
        // if (!fields.website) {
        //     formIsValid = false;
        //     errors.website = "*Please Enter your Website...!";
        // }
        if (!fields.email) {
            formIsValid = false;
            errors.email = "*Please Enter your Email...!";
        }
        if (!fields.country_id) {
            formIsValid = false;
            errors.country_id = "*Please Select Country...!";
        }
        if (!fields.state_id) {
            formIsValid = false;
            errors.state_id = "*Please Select State...!";
        }
        if (!fields.city_id) {
            formIsValid = false;
            errors.city_id = "*Please Select City...!";
        }

        // if (!fields.company_name) {
        //     formIsValid = false;
        //     errors.company_name = "*Please Company Name...!";
        // }
        // if (!fields.company_street_address) {
        //     formIsValid = false;
        //     errors.company_street_address = "*Please Company Street Address...!";
        // }
        // if (!fields.company_team_name) {
        //     formIsValid = false;
        //     errors.company_team_name = "*Please Company Team Name...!";
        // }
        // if (!fields.company_state) {
        //     formIsValid = false;
        //     errors.company_state = "*Please Company State...!";
        // }
        // if (!fields.company_zip_code) {
        //     formIsValid = false;
        //     errors.company_zip_code = "*Please Company Zip Code...!";
        // }
        // if (!fields.home_number) {
        //     formIsValid = false;
        //     errors.home_number = "*Please Enter Home Number...!";
        // }
        // if (!fields.number_of_years_in_business) {
        //     formIsValid = false;
        //     errors.number_of_years_in_business = "*Please Enter number of years in business...!";
        // }
        // if (!fields.designations) {
        //     formIsValid = false;
        //     errors.designations = "*Please Enter Designations...!";
        // }
        // if (!fields.languages_spoken) {
        //     formIsValid = false;
        //     errors.languages_spoken = "*Please Enter Languages Spoken...!";
        // }
        // if (!fields.hobbies) {
        //     formIsValid = false;
        //     errors.hobbies = "*Please Enter Hobbies...!";
        // }
        // if (!fields.cites_expert) {
        //     formIsValid = false;
        //     errors.cites_expert = "*Please Enter Cites Expert...!";
        // }
        // if (!fields.subdivisions_expert) {
        //     formIsValid = false;
        //     errors.subdivisions_expert = "*Please Enter Subdivisions ExpertExpert...!";
        // }
        // if (!fields.facebook_link) {
        //     formIsValid = false;
        //     errors.facebook_link = "*Please Enter Facebook Link...!";
        // }
        // if (!fields.instagram_link) {
        //     formIsValid = false;
        //     errors.instagram_link = "*Please Enter Instagram Link...!";
        // }
        // if (!fields.twitter_link) {
        //     formIsValid = false;
        //     errors.twitter_link = "*Please Enter Twitter Link...!";
        // }


        this.setState({errors: errors}, () => {
            const ID = Object.keys(errors)[0];
            console.log({ID});
            document.getElementById(ID) && document.getElementById(ID).scrollIntoView();
        });
        return formIsValid;
    };
    onChange = e => this.setState({[e.target.name]: e.target.value});

    onSaveSubmit = e => {
        e.preventDefault();
        if (this.handleSaveValidation()) {
        const {
            name,
            specialty,
            website,
            email,
            mobile,
            gender,
            zip_code,
            company_name,
            company_team_name,
            company_state,
            company_zip_code,
            number_of_years_in_business,
            designations,
            languages_spoken,
            hobbies,
            cites_expert,
            subdivisions_expert,
            facebook_link,
            instagram_link,
            twitter_link,
            avatar,
            company_logo
        } = this.state;
        const country = this.state.country_id;
        const state = this.state.state_id;
        const city = this.state.city_id;
        // const avatar = this.state.avatar.split('/')[3];
        // const avatar ='image-1634538806655.png';
        // const company_logo = 'image-1634538806655.png';
        // const company_logo = this.state.company_logo;

        const reqiest = {
            name,
            specialty,
            website,
            email,
            mobile,
            gender,
            zip_code,
            company_name,
            company_team_name,
            company_state,
            company_zip_code,
            number_of_years_in_business,
            designations,
            languages_spoken,
            hobbies,
            cites_expert,
            subdivisions_expert,
            facebook_link,
            instagram_link,
            twitter_link,
            country,
            state,
            city,
            avatar,
            company_logo
        };

        this.props.actionAddUpdateProfile(reqiest, this.state._id && this.state._id)
        }

    };

    render() {
        const {user, addProfileLoader} = this.props.auth;
        const {errors, src, crop, cp_src, company_profile_crop} = this.state;
        const {categoryLoader, categories, subCategoryLoader, subCategories, getUnitOfMeasuresLoader, unitOfMeasures, getCountriesLoader, countries, getSatesLoader, c, getCitiesLoader, cities, addPropertyLoader, states} = this.props.property;

        const countryData = (countries && countries.length > 0) && countries.map(c => {
            return {
                name: c.name,
                value: c._id
            }
        });


        const stateData = (states && states.length > 0) && states.map(s => ({
            name: s.name,
            value: s._id
        }));
        const cityData = (cities && cities.length > 0) && cities.map(c => ({
            name: c.name,
            value: c._id
        }));
        return (
            <Fragment>
                <Navbar scenario={USER_PROFILE}/>
                <HeroSection title="Profile"/>
               <div className="container mt-5">
                   <Form className="card d-flex bg-transparent border-0" autoComplete="off" noValidate={true} onSubmit={this.onSaveSubmit}>
                      {/* <h2 className="text-center mb-2">Profile</h2>*/}
                       <Row className="cards mt-2" style={{width: "100%"}} autoComplete="off" noValidate={true}
                            onSubmit={this.onSaveSubmit}>
                           <Col lg={12} xl={12}>
                               <h5><i className="fas fa-user-tie"/>  Agent Info</h5>
                           </Col>
                               <div className="col-12 text-center">
                                   <div className="agentprofile-container text-center"><img
                                       className="profile-image"
                                       src={this.state.avatar_preview ? this.state.avatar_preview : userLogo}
                                       alt="img"/>
                                       {this.state.profilePicLoader ?
                                           <div className="add-media">
                                               <i className="fa fa-spinner fa-pulse"
                                                  style={{
                                                      color: '#fda94f',
                                                      boxShadow: 'none',
                                                      fontSize: 25
                                                  }}/>
                                           </div> :
                                           <div className="add-media" data-toggle="modal"
                                                data-target="#profilePictureUpload">
                                               <i className="fa fa-pencil"/>
                                           </div>}
                                   </div>
                               </div>
                           <CommonInputField
                               type={'text'}
                               name={'name'}
                               label={'Name'}
                               placeholder={'Please Enter Name'}
                               value={this.state.name}
                               onChange={this.onChange}
                               error={errors.name}
                               require={true}
                           />
                           <CommonInputField
                               type={'text'}
                               name={'specialty'}
                               label={'Specialty'}
                               placeholder={'Please Enter Specialty'}
                               value={this.state.specialty}
                               onChange={this.onChange}
                               error={errors.specialty}
                               require={true}
                           />
                           <CommonInputField
                               type={'text'}
                               name={'website'}
                               label={'Website'}
                               placeholder={'Please Enter Website'}
                               value={this.state.website}
                               onChange={this.onChange}
                               error={errors.website}
                               require={true}
                           />
                           <CommonInputField
                               type={'email'}
                               name={'email'}
                               label={'Email'}
                               placeholder={'Please Enter Email'}
                               value={this.state.email}
                               onChange={this.onChange}
                               error={errors.email}
                               require={true}
                           />
                           <CommonInputField
                               type={'number'}
                               name={'mobile'}
                               label={'mobile'}
                               placeholder={'Please Enter Mobile'}
                               value={this.state.mobile}
                               onChange={this.onChange}
                               error={errors.mobile}
                               require={true}
                               disabled={true}
                           />
                          {/* <div className="col-md-6">
                               <div className="rld-single-input">
                                   <PhoneInput
                                       name="mobile"
                                       id="mobile"
                                       placeholder="Mobile"
                                       autoComplete="off"
                                       country={'in'}
                                       // prefix={+}
                                       onlyCountries={['in']}
                                       enableAreaCodeStretch
                                       specialLabel={false}
                                       disabled={true}
                                       value={this.state.mobile}
                                       onChange={(value) => this.setState({mobile: value})}
                                       international={true}
                                       className={classnames({
                                           'is-invalid': errors.mobile
                                       })}
                                   />

                                   {errors.mobile &&
                                   <span className='text-danger'>{errors.mobile}</span>}
                                   <Link to={'/change-mobile-number'} className="text-primary"> Change
                                       Mobile Number</Link>
                               </div>
                           </div>*/}
                           <div className="col-lg-6 mt-2">
                               <div><label htmlFor="">Gender</label></div>
                               <div className="rld-input" onChange={this.onChange}>
                                   <input type="radio" value="M"
                                          checked={this.state.gender === "M"}
                                          name="gender"/> Male &nbsp;
                                   <input type="radio" value="F"
                                          checked={this.state.gender === "F"}
                                          name="gender"/> Female
                               </div>
                           </div>
                       </Row>
                       <Row className="cards mt-2" style={{width: "100%"}}>
                           <Col lg={12} xl={12}>
                               <h5><i className="fas fa-map-marker-alt"/>  Address</h5>
                           </Col>
                           <div className="form-group col-md-6">
                               <label htmlFor="inputEmail4">Country <span className="text-danger">*</span></label>
                               <SelectSearch
                                   options={countryData ? countryData : []}
                                   value={this.state.country_id}
                                   onChange={(country_id) => this.setState({
                                       country_id,
                                       state_id: '',
                                       city_id: ''
                                   }, () => {
                                       this.props.actionRemoveStates();
                                       this.props.getStates(country_id)
                                   })}

                                   name="country_id"
                                   id="country_id"
                                   autoComplete="none"
                                   placeholder="Choose your country"
                                   disabled={!countryData.length}
                                   search={true}/>
                               {errors.country_id &&
                               <span className='text-danger'>{errors.country_id}</span>}
                           </div>


                           <div className="form-group col-md-6">
                               <label htmlFor="inputEmail4">State <span
                                   className="text-danger">*</span></label>
                               <SelectSearch
                                   options={stateData ? stateData : []}
                                   // getOptions={(query) => this.props.getStates(this.state.country_id)}
                                   value={this.state.state_id}
                                   onChange={(state_id) => this.setState({
                                       state_id,
                                       city_id: ''
                                   }, () => {
                                       this.props.actionRemoveCities();
                                       this.props.getCities(state_id);

                                   })}
                                   name="state_id"
                                   id="state_id"
                                   autoComplete="none"
                                   placeholder="Choose your state"
                                   disabled={!this.state.country_id}
                                   search={true}/>

                               {errors.state_id &&
                               <span className='text-danger'>{errors.state_id}</span>}
                           </div>
                           <div className="form-group col-md-6">
                               <label htmlFor="inputEmail4">city <span
                                   className="text-danger">*</span></label>
                               <SelectSearch
                                   options={cityData ? cityData : []}
                                   // getOptions={(query) => this.props.actionGetCity(`state_id=${this.state.state_id}&q=${query}`)}
                                   value={this.state.city_id && this.state.city_id}
                                   onChange={(city_id) => this.setState({city_id})}
                                   name="city_id"
                                   id="city_id"
                                   autoComplete="none"
                                   placeholder="Choose your city"
                                   disabled={!this.state.state_id || !this.state.country_id}
                                   search={true}/>
                               {errors.city_id &&
                               <span className='text-danger'>{errors.city_id}</span>}
                           </div>

                           <CommonInputField
                               type={'text'}
                               name={'zip_code'}
                               onChange={this.onChange}
                               error={errors.zip_code}
                               label={'Zip Code'}
                               value={this.state.zip_code}
                               require={true}
                               placeholder={'Please Enter Zip Code'}
                           />
                       </Row>
                       <Row className="cards mt-2" style={{width: "100%"}}>
                           <Col lg={12} xl={12}>
                               <h5><i className="fas fa-info"/>  Company  Info</h5>
                           </Col>
                           <div className="col-12 text-center">
                               <div className="companyprofile-container text-center"><img
                                   src={this.state.company_logo_preview ? this.state.company_logo_preview: userCompLogo}
                                   alt="img"/>
                                   {this.state.profilePicLoader ?
                                       <div className="add-media" style={{background: 'red'}}>
                                           <i className="fa fa-spinner fa-pulse"
                                              style={{color: '#fda94f', boxShadow: 'none'}}/>
                                       </div> :
                                       <div className="add-media" data-toggle="modal"
                                            data-target="#companyprofilePictureUpload">
                                           <i className="fa fa-pencil"/>
                                       </div>}
                               </div>
                           </div>
                           <CommonInputField
                               type={'text'}
                               name={'company_name'}
                               onChange={this.onChange}
                               error={errors.company_name}
                               label={'Company Name'}
                               value={this.state.company_name}
                               require={false}
                               placeholder={'Please Enter Company Name'}
                           />
                           <CommonInputField
                               type={'text'}
                               name={'company_team_name'}
                               onChange={this.onChange}
                               error={errors.company_team_name}
                               label={'Company Team Name'}
                               value={this.state.company_team_name}
                               require={false}
                               placeholder={'Please Enter Company Team Name'}
                           />
                           <CommonInputField
                               type={'number'}
                               name={'number_of_years_in_business'}
                               onChange={this.onChange}
                               error={errors.number_of_years_in_business}
                               label={'Number Of Years In Business'}
                               value={this.state.number_of_years_in_business}
                               require={false}
                               placeholder={'Please Enter Number Of Years In Business'}
                           />
                           <CommonInputField
                               type={'text'}
                               name={'designations'}
                               onChange={this.onChange}
                               error={errors.designations}
                               label={'Designations'}
                               value={this.state.designations}
                               require={false}
                               placeholder={'Please Enter Designations'}
                           />
                           <CommonInputField
                               type={'text'}
                               name={'languages_spoken'}
                               onChange={this.onChange}
                               error={errors.languages_spoken}
                               label={'Languages Spoken'}
                               value={this.state.languages_spoken}
                               require={false}
                               placeholder={'Please Enter Languages Spoken'}
                           />

                           <CommonInputField
                               type={'text'}
                               name={'hobbies'}
                               onChange={this.onChange}
                               error={errors.hobbies}
                               label={'Hobbies'}
                               value={this.state.hobbies}
                               require={false}
                               placeholder={'Please Enter Hobbies'}
                           />
                           <CommonInputField
                               type={'text'}
                               name={'cites_expert'}
                               onChange={this.onChange}
                               error={errors.cites_expert}
                               label={'Cites Expert'}
                               value={this.state.cites_expert}
                               require={false}
                               placeholder={'Please Enter Cites Expert'}
                           />
                           <CommonInputField
                               type={'text'}
                               name={'subdivisions_expert'}
                               onChange={this.onChange}
                               error={errors.subdivisions_expert}
                               label={'Subdivisions Expert'}
                               value={this.state.subdivisions_expert}
                               require={false}
                               placeholder={'Please Enter Subdivisions Expert'}
                           />
                           <CommonTextBox
                               name={'company_street_address'}
                               onChange={this.onChange}
                               error={errors.company_street_address}
                               label={'Company Address'}
                               value={this.state.company_street_address}
                               required={false}
                               placeholder={'Please Enter Company Address'}
                           />


                       </Row>
                       <Row className="cards mt-2" style={{width: "100%"}}>
                           <Col lg={12} xl={12}>
                               <h5><i className="fas fa-comments"/>  Social Link</h5>
                           </Col>
                           <CommonInputField
                               type={'text'}
                               name={'facebook_link'}
                               onChange={this.onChange}
                               error={errors.facebook_link}
                               label={'Facebook'}
                               value={this.state.facebook_link}
                               require={false}
                               placeholder={'Please Enter Facebook Link'}
                           />
                           <CommonInputField
                               type={'text'}
                               name={'instagram_link'}
                               onChange={this.onChange}
                               error={errors.instagram_link}
                               label={'Instagram'}
                               value={this.state.instagram_link}
                               require={false}
                               placeholder={'Please Enter Instagram Link'}
                           />
                           <CommonInputField
                               type={'text'}
                               name={'twitter_link'}
                               onChange={this.onChange}
                               error={errors.twitter_link}
                               label={'Twitter'}
                               value={this.state.twitter_link}
                               require={false}
                               placeholder={'Please Enter Twitter Link'}
                           />
                           <div className="col-12 text-center">
                               {addProfileLoader ?
                                   <button
                                       className="btn btn-success"
                                       type="button">
                                       <img src={btnLoader} alt="login-loader"
                                            style={{width: '22px', margin: '0 15px'}}/>
                                   </button> :
                                   <button
                                       className="btn btn-success"
                                       type="submit">Save
                                   </button>}
                           </div>
                       </Row>
                   </Form>
               </div>
                <Fragment>
                    <div className="modal fade" id="profilePictureUpload" role="dialog" data-backdrop="static"
                         data-keyboard="false"
                         aria-labelledby="profilePictureUploadTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Change Profile
                                        Picture</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center">
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            {src ? (
                                                <ReactCrop
                                                    src={src}
                                                    crop={crop}
                                                    ruleOfThirds
                                                    onImageLoaded={this.onImageLoaded}
                                                    onComplete={this.onCropComplete}
                                                    onChange={this.onCropChange}
                                                    className={'profile-preview-image'}
                                                />
                                            ) : <img width={250}
                                                     src={this.state.avatar_preview ? this.state.avatar_preview : userLogo}
                                                     alt="Profile Picture"/>}
                                        </div>
                                    </div>
                                    <hr/>
                                    <input id={'profile-pic-selector'} type="file" accept="image/*"
                                           onChange={this.onSelectFile}/>

                                </div>
                                <div className="modal-footer">
                                    <button id={'close-profilePictureUpload'} type="button"
                                            className="btn btn-danger" data-dismiss="modal">Close
                                    </button>
                                    <button className="btn btn-success" onClick={this.handleProfileChange}>Save
                                        changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="companyprofilePictureUpload" role="dialog"
                         data-backdrop="static"
                         data-keyboard="false"
                         aria-labelledby="companyprofilePictureUploadTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Change Company Profile
                                        Picture</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center">
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            {cp_src ? (
                                                <ReactCrop
                                                    src={cp_src}
                                                    crop={company_profile_crop}
                                                    ruleOfThirds
                                                    onImageLoaded={this.onCompanyImageLoaded}
                                                    onComplete={this.onCompanyImageCropComplete}
                                                    onChange={this.onCompanyImageCropChange}
                                                    className={'company-profile-preview-image'}
                                                />
                                            ) : <img width={250}
                                                     src={this.state.company_logo_preview ? this.state.company_logo_preview: userCompLogo}
                                                     alt="Company Profile Picture"/>}
                                        </div>
                                    </div>
                                    <hr/>
                                    <input id={'company-profile-pic-selector'} type="file" accept="image/!*"
                                           onChange={this.onSelectCompanyProfileFile}/>

                                </div>
                                <div className="modal-footer">
                                    <button id={'close-companyprofilePictureUpload'} type="button"
                                            className="btn btn-danger" data-dismiss="modal">Close
                                    </button>
                                    <button className="btn btn-success"
                                            onClick={this.handleCompanyProfileChange}>Save
                                        changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            </Fragment>
        );
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    property: state.property,
});

export default connect(mapStateToProps, {
    getAllCountry,
    actionRemoveCountries,
    actionRemoveStates,
    actionRemoveCities,
    getStates,
    actionAddUpdateProfile,
    actionGetProfileData,
    actionAddUpdateUserProfilePic,
    getCities,
})(UserProfile);

